module.exports = __webpack_public_path__ + "static/media/envelope.e6183603.svg";